export const GET_CHART = 'chart/get';
export const GET_CHART_SUCCESS = 'chart/get/success';
